import XAPI, { DocumentJson } from "@xapi/xapi";
import { UserDownloadDto } from "collaboration-service";

const endpoint = "https://test-sw.azurewebsites.net/xapi/";
const verbsAddress = "https://imaginarity.com/expapi/verbs/";

export class ImgXapi {
    private _xapi: XAPI = new XAPI({ endpoint: endpoint });
    private _actor: any = {
        objectType: "Agent",
        collaborationUserId: 'unknown',
        mbox: 'undefined',
        name: 'undefined',
    };

    private static _instance: ImgXapi | undefined;
    public static getInstance(user: UserDownloadDto) {
        if (!this._instance) {
            this._instance = new ImgXapi(user);
        }
        return this._instance;
    }

    private constructor(user: UserDownloadDto) {
        this._actor = {
            objectType: "Agent",
            collaborationUserId: user.id,
            mbox: user.email,
            name: user.firstName + ' ' + user.secondName,
        };
    }

    public xapiState = (activityId: string, stateId: string, state: DocumentJson, verb: string) => {
        state.userId = this._actor.collaborationUserId;
        this._xapi.createState({
            agent: this._actor as any,
            activityId,
            stateId: activityId + stateId,
            state,
        })
            .then((res: any) => {
                console.log('createState res', res);

            })
            .catch((error: any) => {
                console.log('createState error', error);

            });
        this.xapiStatement(verb, activityId);
    }

    public xapiStatement = (verb: string, objectId: string) => {
        this._xapi.sendStatement({
            statement: {
                actor: this._actor,
                verb: {
                    id: verbsAddress + verb,
                    display: { 'en-EN': verb },
                },
                object: {
                    objectType: "Activity",
                    id: objectId,
                }
            } as any,
        })
            .then((res: any) => {
                console.log('sendStatement res', res);

            }).catch((error: any) => {
                console.log('sendStatement error', error);

            });
    }

    public getXapiStatements = async () => {
        const res = await this._xapi.getStatements({ agent: this._actor as any });
        if (res) {
            return res.data;
        }
    }
    public getXapiStates = async (activityId: string) => {
        const res = await this._xapi.getStates({
            agent: this._actor as any,
            activityId
        });
        if (res) {
            return res;
        }
    }
}